// imove-behavior: 初始化公共参数

import { getLoginUserInfo } from '@tencent/calendar-framework-wemeet-login';

const getObjFromStorage = (key) => {
  if (typeof window === 'undefined') return '';
  const value = window.localStorage.getItem(key) || sessionStorage.getItem(key) || '';
  return value;
};

export default async function(ctx) {
  const userData = await getLoginUserInfo();
  const appId = userData?.app_id || getObjFromStorage('app_id') || getObjFromStorage('safe_id_appId') || '';
  const appUid = userData?.userid || userData?.app_uid || getObjFromStorage('app_uid') || getObjFromStorage('safe_id_appUid') || '';
  const commonParams = {
    env_id: appId,
    corp_id: appId,
    uid: appUid,
  };
  return {
    webReport: ctx.getPipe(),
    commonParams,
  };
}